// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Overlay{position:fixed;left:0;top:0;right:0;bottom:0;z-index:1000;cursor:auto;display:block}.Overlay--dimmed{background-color:rgba(0,0,0,.4)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
